const getLang = () => {
  return localStorage.getItem('lang', 'en');
};

export default getLang;
